import { useCallback, useEffect, useState, Fragment } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Toast from "helper/toast";
import { Grid } from "@mui/material";
import {
  StyledPaper,
  StyledButton,
  StyledDivButton,
  StyledTitle,
  StyledDivIcon,
  StyledDivtext,
  StyledGrid,
  StyledLink,
} from "./Contact.style";
import ContactCM from "components/contactus";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { BsInstagram } from "react-icons/bs";
import { getContactUsRequest, addContactUsMessageRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import TextField from "@mui/material/TextField";
import useHttp from "hooks/use-http";
import Container from "@mui/material/Container";
import { contactSchema } from "validations";
import MenuCM from "components/shared/menu";
import Alert from "@mui/material/Alert";
import FooterCM from "components/shared/footer";
import {Helmet} from "react-helmet";

export default function ContactUs() {
  const { request, loading } = useHttp();
  const [contact, setContact] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(contactSchema),
  });

  const getContact = useCallback(async () => {
    let res = await request({
      url: getContactUsRequest,
      values: {},
    });
    setContact(res);
  }, [request]);

  useEffect(() => {
    getContact();
  }, [getContact]);

  const onSubmit = async (values) => {
    const res = await request({
      url: addContactUsMessageRequest,
      values,
    });
    if (res) {
      reset({
        full_name: "",
        email: "",
        message: "",
      });
      Toast({ type: "success", title: "ارسال پيام" });
    }
  };

  return (
    <div>
      <Helmet>
        <title>تماس با ما - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="تماس با ما" />
          <Container>
            <Grid sx={{ marginTop: "30px", marginBottom: "30px" }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12974.458443765881!2d51.3063468!3d35.612572!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7c243daeea5a27a6!2z2YXYqNmE2YXYp9mGINmI24zZiNmQ2YQ!5e0!3m2!1sen!2s!4v1660941088352!5m2!1sen!2s"
                width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{
                  background: "white",
                  border: "0",
                  borderRadius: "15px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px",
                }}
              ></iframe>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={8} xs={12}>
                <StyledPaper elevation={3}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} mb={2} sx={{ padding: "0 !important" }}>
                      <StyledTitle>فرم تماس با ما</StyledTitle>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        label="نام و نام خانوادگی"
                        defaultValue=""
                        size="small"
                        id="full_name"
                        {...register("full_name")}
                        error={Boolean(errors.full_name)}
                        helperText={errors.full_name?.message}
                        fullWidth
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        label="ایمیل"
                        defaultValue=""
                        size="small"
                        id="email"
                        {...register("email")}
                        error={Boolean(errors.email)}
                        helperText={errors.email?.message}
                        fullWidth
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <TextField
                        label="پيام"
                        defaultValue=""
                        multiline
                        rows={5}
                        id="message"
                        {...register("message")}
                        error={Boolean(errors.message)}
                        helperText={errors.message?.message}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <StyledDivButton>
                    <StyledButton
                      variant="contained"
                      onClick={handleSubmit(onSubmit)}
                    >
                      ارسال پيام
                    </StyledButton>
                  </StyledDivButton>
                </StyledPaper>
              </Grid>
              <StyledGrid item md={4} xs={12}>
                <StyledPaper
                  elevation={3}
                  sx={{ display: "flex", marginBottom: "2px" }}
                >
                  <StyledDivIcon>
                    <LocationOnIcon />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>آدرس</h4>
                    <p style={{ color: "#4b4b4b" }}>{contact?.a?.address}</p>
                    {/* <p>{contact?.b?.address}</p> */}
                  </StyledDivtext>
                </StyledPaper>
                <StyledPaper
                  elevation={3}
                  sx={{
                    display: "flex",
                    marginTop: "3px",
                    marginBottom: "3px",
                  }}
                >
                  <StyledDivIcon>
                    <PhoneIcon />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>شماره تماس</h4>
                    <p>
                      <a href={"tel:" + contact?.a?.phone_number}>
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.phone_number}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a href={"tel:" + contact?.b?.phone_number}>
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.phone_number}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
                <StyledPaper
                  elevation={3}
                  sx={{ display: "flex", marginTop: "2px" }}
                >
                  <StyledDivIcon>
                    <BsInstagram size="26" />
                  </StyledDivIcon>
                  <StyledDivtext>
                    <h4>اینستاگرام</h4>
                    <p>
                      <a
                        href={
                          "https://www.instagram.com/" + contact?.a?.instagram
                        }
                        target="_blank"
                      >
                        مبلمان :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.a?.instagram}
                        </span>
                      </a>
                    </p>
                    <p>
                      <a
                        href={
                          "https://www.instagram.com/" + contact?.b?.instagram
                        }
                        target="_blank"
                      >
                        اکسسوری :{" "}
                        <span style={{ color: "#4b4b4b" }}>
                          {contact?.b?.instagram}
                        </span>
                      </a>
                    </p>
                  </StyledDivtext>
                </StyledPaper>
              </StyledGrid>
            </Grid>
            <Alert severity="info" sx={{ marginBottom: "30px" }}>
              برای یافتن پاسخ سوالات خود روی لینک مقابل کلیک کنید
              <StyledLink to="/questions">پرسش های متداول</StyledLink>
            </Alert>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </div>
  );
}
